module.exports = __webpack_public_path__ + "img/P2-C1.fea6b60b.svg";